import { createFileRoute } from '@tanstack/react-router';
import { Group, Stack, Text, Title } from '@mantine/core';
import { IconApps } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { PermissionGate } from '../../components/PermissionGate';
import { ConnectedAppsPanel } from '../../components/webhooks/ConnectedAppsPanel';

function ConnectedAppsPage() {
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
      <Stack gap="md">
        <Group gap="sm">
          <IconApps size={22} />
          <Title order={2}>Connected apps</Title>
        </Group>
        <Text c="dimmed" size="sm">
          Apps connected through the public API (Zapier, Make, Pabbly, or your own integration)
          register their own delivery URLs here.
        </Text>
        <ConnectedAppsPanel />
      </Stack>
    </motion.div>
  );
}

function ConnectedAppsGated() {
  return (
    <PermissionGate permission="manage_integrations">
      <ConnectedAppsPage />
    </PermissionGate>
  );
}

export const Route = createFileRoute('/vendor/integrations/connected-apps')({
  component: ConnectedAppsGated,
});
